import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RegionState {
  selectedValue: any;
}

const initialState: RegionState = {
  selectedValue: 1,
};

const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    setSelectedValueData: (state, action: PayloadAction<any>) => {
      state.selectedValue = action.payload;
    },
  },
});

export const { setSelectedValueData } = statusSlice.actions;
export default statusSlice.reducer;
